var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apollo-mutation',_vm._g({attrs:{"mutation":_vm.$options.destroyDesignMutation,"variables":{
    filenames: _vm.filenames,
    projectPath: _vm.projectPath,
    iid: _vm.iid,
  },"update":_vm.updateStoreAfterDelete,"tag":null},scopedSlots:_vm._u([{key:"default",fn:function({ mutate, loading, error }){return [_vm._t("default",null,null,{ mutate, loading, error })]}}],null,true)},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }